import React from "react";
import styled from "styled-components";

import InputGroup from "./InputGroup";
import InputLabel from "./InputLabel";
import SkeletonBox from "../SkeletonBox";

const RadioInputGroup = styled(InputGroup)`
  width: auto;
  margin-bottom: 0;
  margin-top: 0;
`;

// TODO: fix radio button labels being uneven with (preferred) text

const RadioLabel = styled(InputLabel)`
  position: relative;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 5px 2em 5px 5px;
  cursor: pointer;
  top: auto;
  left: auto;
  opacity: 1;
  font-weight: 400;
  @media (min-width: 768px) {
    font-size: 1.125em;
  }
  &:before {
    background: ${(props) =>
      props.checked ? props.theme.color.oldBlue : `#ffffff`};
    content: "";
    box-shadow: inset 0px 0px 0px 5px #fff;
    border: 1px solid ${(props) => props.theme.color.gray};
    display: inline-block;
    vertical-align: middle;
    width: 24px;
    height: 24px;
    padding: 0;
    margin-right: 10px;
    text-align: center;
    border-radius: 50%;
    opacity: 1;
    flex-shrink: 0;
  }
`;

const StyledRadioButton = styled.input`
  opacity: 0;
  margin: 5px;
  padding: 0 1em;
  max-width: 400px;
  border: 1px solid ${(props) => props.theme.color.gray};
  line-height: 50px;
  font-size: 1.06em;
  border-radius: 4px;
  box-shadow: inset -1.6px 2.5px 1px 0 rgb(0 0 0 / 8%);
  padding-left: 1em;
  padding-right: 1em;
  box-sizing: border-box;
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  width: auto;
  height: auto;
`;

function RadioButton({ children, checked, id, theme, ...rest }) {
  return (
    <SkeletonBox>
      <RadioInputGroup>
        <StyledRadioButton
          type="radio"
          checked={checked}
          id={id}
          theme={theme}
          {...rest}
        />
        <RadioLabel checked={checked} htmlFor={id} theme={theme}>
          {children}
        </RadioLabel>
      </RadioInputGroup>
    </SkeletonBox>
  );
}

export default RadioButton;
